/** @format */
import { Divider } from '@mpb-com/feather/components/atoms/divider';
import React from 'react';
import styled, { css } from 'styled-components';

import { SearchFacet } from '@toucan/common/services/search/constants';

import { smallTablet } from '@toucan/client/global/application';

import { Filter } from '@toucan/client/features/search/components/model-search-results/types';

import { FilterResultsSummary } from './components/filter-results-summary';
import { SearchFilterGroup } from './components/search-filter-group';

export const StyledInlineFilters = styled.div`
    padding-bottom: var(--layout-spacing-12);

    ${smallTablet(css`
        padding-bottom: 0;
    `)}
`;

export function InlineFilters({
    testId,
    filters,
    isLoadingFilters,
    handleFilterOpen,
}: {
    testId: string;
    filters: Filter[];
    isLoadingFilters: boolean;
    handleFilterOpen: (id: SearchFacet) => Promise<void>;
}) {
    return (
        <StyledInlineFilters>
            <section
                className="desktop-filters"
                data-testid={`${testId}__filters__desktop`}
            >
                <FilterResultsSummary
                    filters={filters}
                    data-testid={`${testId}__filter-summary`}
                />
                <SearchFilterGroup
                    isLoading={isLoadingFilters}
                    filters={filters}
                    data-testid={`${testId}__filters`}
                    onFilterOpen={handleFilterOpen}
                />
            </section>
            <Divider className="divider" />
        </StyledInlineFilters>
    );
}
